module.exports = __webpack_public_path__ + "static/media/218.0adb5481.svg";